// loader.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$: Observable<boolean> = this.isLoadingSubject.asObservable();
  private activeRequests = 0;

  showLoader(): void {
    this.activeRequests++;
    if (this.activeRequests === 1) { // Show loader only when the first request starts
      this.isLoadingSubject.next(true);
    }
  }

  hideLoader(): void {
    this.activeRequests--;
    if (this.activeRequests === 0) { // Hide loader only when all requests complete
      this.isLoadingSubject.next(false);
    }
  }
}